import { Box, Modal, Title } from '@nimbus-ds/components';
import { FakeProgressBar } from 'commons/components';
import { useTranslationCatalog } from 'domains/Catalog/hooks';
import GeneratingAiAnimation from './generating-ai.gif';

interface FakeProgressBarAIModalProps {
  promise: Promise<unknown>;
  onFinish: () => void;
  onError: () => void;
}

function FakeProgressBarAIModal({
  promise,
  onFinish,
  onError,
}: Readonly<FakeProgressBarAIModalProps>) {
  const t = useTranslationCatalog('products.fromImages.modal.creating');

  const steps = [
    { name: t('title'), duration: 20 },
    { name: t('description'), duration: 20 },
    { name: t('weightsAndDimensions'), duration: 20 },
    { name: t('categories'), duration: 20 },
    { name: t('tagsBrandAndSeo'), duration: 20 },
  ];

  return (
    <Modal open maxWidth="360px" padding="none">
      <Modal.Body>
        <Box
          display="flex"
          flexDirection="column"
          gap="2"
          height="288px"
          justifyContent="center"
          alignItems="center"
        >
          <img
            alt={t('mainTitle')}
            src={GeneratingAiAnimation}
            width={80}
            height={80}
          />
          <Title as="h4">{t('mainTitle')}</Title>
          <FakeProgressBar
            promise={promise}
            appearance="ai-generative"
            onFinish={onFinish}
            steps={steps}
            onError={onError}
            minAnimationDuration={12000}
          />
        </Box>
      </Modal.Body>
    </Modal>
  );
}

export default FakeProgressBarAIModal;
